try {
  var scriptElement = document.createElement("script");
  var sourceUrl = "https://sdk.breeze.in/electron/163.0.0/index.js";
  scriptElement.setAttribute("src", sourceUrl);
  scriptElement.setAttribute("type", "module");
  scriptElement.setAttribute("id", "breeze-script-tag");
  scriptElement.setAttribute("data-environment", "release");
  scriptElement.setAttribute("data-platform", "shopify");
  scriptElement.setAttribute("data-enable-external-trackers", "true");
  scriptElement.setAttribute("data-enable-snap-tracker", "true");
  scriptElement.setAttribute("data-enable-ga", "true");
  scriptElement.setAttribute("data-enable-fbp", "true");
  scriptElement.setAttribute("data-emit-tracker-events", "true");
  scriptElement.setAttribute("data-ga4-measurement-id", "G-GXB98JS7J3");
  scriptElement.setAttribute("data-merchantid", "a2cricket");
  scriptElement.setAttribute("data-ga-version", "new");
  scriptElement.setAttribute("ghost-mode", "false");
  document.head.append(scriptElement);
} catch (e) {
  console.log("Something went wrong");
}
window.bzGhostMode = false;
window.addToCartSelector = "";
window.buyNowSelector = "";
window.checkoutSelector = "";
window.bzInternationalConfig = {
  enable: true,
};
